<li class="main-navigation-sidenav-list-item">
  <a
    class="main-navigation-sidenav-link"
    [routerLink]="'/' + link.route"
    routerLinkActive="active"
    #linkActive="routerLinkActive"
  >
    <svg
      attr.aria-label="{{ link.ariaLabel }}"
      class="main-navigation-sidenav-icon"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        attr.d="{{ link.iconPath }}"
      ></path>
    </svg>
    {{ link.label | translate }}
  </a>
</li>
